import React from "react";
import { X, Folder, Lock, Globe } from "lucide-react";

const CreateFolderModal = ({ open, onClose, form, onChange, onSubmit }) => {
  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-lg font-medium text-gray-900 flex items-center gap-2">
            <Folder className="w-5 h-5" />새 폴더 만들기
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label
              htmlFor="folder_name"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              폴더 이름
            </label>
            <input
              type="text"
              id="folder_name"
              value={form.folder_name}
              onChange={(e) =>
                onChange({ ...form, folder_name: e.target.value })
              }
              placeholder="폴더 이름을 입력하세요"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              autoFocus
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              폴더 유형
            </label>
            <div className="space-y-2">
              <label className="flex items-center p-3 border border-gray-200 rounded-md cursor-pointer hover:bg-gray-50">
                <input
                  type="radio"
                  name="folder_type"
                  value="private"
                  checked={form.folder_type === "private"}
                  onChange={(e) =>
                    onChange({ ...form, folder_type: e.target.value })
                  }
                  className="mr-3"
                />
                <Lock className="w-4 h-4 mr-2 text-gray-600" />
                <div>
                  <div className="font-medium text-gray-900">개인 폴더</div>
                  <div className="text-sm text-gray-500">나만 접근 가능</div>
                </div>
              </label>

              <label className="flex items-center p-3 border border-gray-200 rounded-md cursor-pointer hover:bg-gray-50">
                <input
                  type="radio"
                  name="folder_type"
                  value="share"
                  checked={form.folder_type === "share"}
                  onChange={(e) =>
                    onChange({ ...form, folder_type: e.target.value })
                  }
                  className="mr-3"
                />
                <Globe className="w-4 h-4 mr-2 text-green-600" />
                <div>
                  <div className="font-medium text-gray-900">공유 폴더</div>
                  <div className="text-sm text-gray-500">멤버 초대 가능</div>
                </div>
              </label>
            </div>
          </div>

          <div className="flex justify-end gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
            >
              취소
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              만들기
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateFolderModal;
